import styles from "./styles.module.css";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import { Button } from "@mui/material";

export default function LogoutConfirmDialog({ open, onClose, onConfirm }) {
  if (!open) return null;

  return (
    <div className={styles.popUp}>
      <div className={styles.contentWrapper}>
        <div className={styles.headInfoSec}>
          <h2>Confirm Logout</h2>
          <CloseRoundedIcon onClick={onClose} className={styles.icon} />
        </div>

        <div className={styles.contentArea}>
          <h3 className={styles.subTitle}>Are you sure you want to log out from your account?</h3>
        </div>

        <div className={styles.buttonSection}>
          <Button onClick={onClose} className={styles.buttonGray}>
            Cancel
          </Button>
          <Button onClick={onConfirm} className={styles.buttonRed}>
            Logout
          </Button>
        </div>
      </div>
    </div>
  );
}
